import { CarrierDetailRow } from './CarrierDetailRow'
import { Disclosure } from './Disclosure'
import { InsuranceType } from './quoteCardTypes'
import { QuoteCardSection } from './quotesAnalytics'

const SUMMARY: Record<InsuranceType, string> = {
  [InsuranceType.ADMITTED]: 'Admitted',
  [InsuranceType.NON_ADMITTED]: 'Non-admitted',
}

const NO_STATE_BACKSTOP = "If the insurance company goes under, the state won't step in to pay your claims."

const COPY: Record<InsuranceType, string> = {
  [InsuranceType.ADMITTED]:
    'No surplus lines taxes and fees. If the insurance company goes under, the state will step in to pay your claims up to a cap.',
  [InsuranceType.NON_ADMITTED]: `You'll pay roughly 2–6% extra on top of the premium in surplus lines taxes and fees. ${NO_STATE_BACKSTOP}`,
}

interface InsuranceTypeSectionProps {
  /** Unset when we don't know whether this carrier is admitted for the customer's state. */
  insuranceType?: InsuranceType | null
  /** The carrier itemised its taxes and fees, so the card's price already covers them. */
  feesIncludedInPrice?: boolean
}

/** Whether the state backstops this policy — the first thing to know about a quote. */
export function InsuranceTypeSection({ insuranceType, feesIncludedInPrice }: InsuranceTypeSectionProps) {
  if (!insuranceType) return <CarrierDetailRow label="Insurance type" />

  const copy =
    insuranceType === InsuranceType.NON_ADMITTED && feesIncludedInPrice
      ? `The price shown already includes surplus lines taxes and fees. ${NO_STATE_BACKSTOP}`
      : COPY[insuranceType]

  return (
    <Disclosure
      section={QuoteCardSection.INSURANCE_TYPE}
      label="Insurance type"
      summary={SUMMARY[insuranceType]}
    >
      <p className="text-ink-700 text-xs leading-relaxed">{copy}</p>
    </Disclosure>
  )
}
